import styled, { css } from 'styled-components';

export const SelectedPoint = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: -${theme.spacing.km4};
    top: 6px;
    width: ${theme.spacing.km2};
    height: ${theme.spacing.km2};
    gap: 0px;
    border-radius: 6px;
    opacity: 0px;
    background: ${theme.color.icon.brand.default};
    border: ${theme.border.width.thinner} ${theme.border.style.solid} ${theme.color.border.neutral.inverted};
  `}
`;
